function isValidDate(date: string) {
  const regex = /^\d{2}\.\d{2}\.\d{4}$/
  if (!regex.test(date)) return false

  const [day, month, year] = date.split('.').map(Number)
  const parsedDate = new Date(year, month - 1, day)

  return (
    parsedDate.getDate() === day &&
    parsedDate.getMonth() === month - 1 &&
    parsedDate.getFullYear() === year
  )
}

const validators = {
  companyName: function (name: string) {
    return /^[\p{L}0-9\s+&%.,|-]{2,}$/u.test(name.trim())
  },

  name: function (name: string) {
    return /^[\p{L}0-9\s'&%.,|-]{2,}$/u.test(name.trim())
  },

  phone: function (phone: string) {
    return phone.trim().length >= 7
  },

  email: function (email: string) {
    return !!email.trim().match(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/g)
  },

  password: function (password: string) {
    let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')

    return strongRegex.test(password)
  },

  pinCode: function (pinCode: string) {
    return /^\d{6}$/.test(pinCode)
  },

  gender: function (gender: string) {
    return !!gender
  },
  date: function (date: string) {
    return isValidDate(date)
  },

  dateOfBirth: function (date: string) {
    return isValidDate(date)
  },

  clientNumber: function (num: number | string) {
    return /^\d{1,10}$/.test(String(num))
  },

  isPerson: function (value: number) {
    return value === 1 || value === 0
  },
}

export default validators
